export function isCssVarColor(color: unknown): boolean {
  return typeof color === 'string' && color.trim().startsWith('var(');
}